import { AfterViewInit, Component, OnInit, signal, WritableSignal } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { SecurityService } from '../../services/security.service';
import { Title } from '@angular/platform-browser';
import { Router, RouterLink } from '@angular/router';
import { ModalComponent } from "../../shared/modal/modal.component";
import { RouteService } from '../../services/route.service';
import { HelpService } from '../../services/help.service';

@Component({
  selector: 'app-finish',
  imports: [ModalComponent, RouterLink],
  templateUrl: './finish.component.html',
  styleUrl: './finish.component.css'
})
export class FinishComponent implements OnInit, AfterViewInit{
  showModalPap = signal(false);
  showModalInfo = signal(false);
  valuesVinculation:any = {
    valueOne: 10000,
    valueTwo: 20000,
  }
  nextRoute: WritableSignal<string> = signal('');
  
  constructor(
    private _router: Router,
    private _title: Title,
    private _securityService: SecurityService,
    private _loaderService: LoaderService,
    private _routeService: RouteService,
    private _helpService: HelpService
    
  ) {
    this.nextRoute.set(this._routeService.getNextRoute(this._router.url) ?? '');
    this._title.setTitle('Onboarding Digital | Finalización');

   }

  ngOnInit(): void {
    this._helpService.hide();
    this._loaderService.hide();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.showModalInfo.set(true);
    }, 1000);
    if(this.showModalInfo() == false){
      setTimeout(() => {
        this.showModalPap.set(true);
      }, 8000);
    }
  }


}
